import {
  Box,
  CircularProgress,
  Grid,
  Stack,
  Typography
} from "@mui/material";
import { GeoPoint, collection, getFirestore, orderBy, query, where } from "firebase/firestore";
import React, { useEffect } from "react";
import AppBarHome from "../components/AppBar/Home";
import LeafletMap from "../components/LeafletMap";
import SpeciesSearch from "../components/SpeciesSearch";
import { getAllData } from "../libs/firebase/firestore/getAllData";
import { getQueryAllData } from "../libs/firebase/firestore/getQueryAllData";
import { useNavigateToTop } from "../libs/useNavigateToTop";

function ScreenHome({}) {
  const navigate = useNavigateToTop();

  // State for tasks data
  const [bonsaiGuides, setBonsaiGuides] = React.useState([]);

  const [species, setSpecies] = React.useState([]);

  const [speciesSearch,  setSpeciesSearch] = React.useState("");

  // loading state
  const [loading, setLoading] = React.useState(true);

  const [guideColours, setGuideColours] = React.useState([]);

  const handleBonsaiGuideClick = (guideId) => {
    navigate(`/bonsai-guide/${guideId}`);
  };

  const handleMapViewChanged = (bounds) => {

    let lowerLat = parseFloat(bounds._southWest.lat);
    let upperLat = parseFloat(bounds._northEast.lat);
    let lowerLon = parseFloat(bounds._southWest.lng);
    let upperLon = parseFloat(bounds._northEast.lng);

    // if longitude is greater than 180 set it to 180
    if (upperLon > 180) {
      upperLon = 180;
    }

    // if longitude is less than -180 set it to -180
    if (lowerLon < -180) {
      lowerLon = -180;
    }

    // Get all bonsai guides in the bounds
    const db = getFirestore();
    let q = query(collection(db, "bonsai-guides"),
    // orderBy("longitude"),
    where("longitude", ">", lowerLon),
    where("longitude", "<", upperLon),
    where("latitude", ">", lowerLat),
    where("latitude", "<", upperLat)
);


    getQueryAllData(q, (bonsaiGuidesData) => {
      setBonsaiGuides(bonsaiGuidesData);
    },
    (error) => {
      console.error("Error getting bonsai guides", error);
    });
  }

  useEffect(() => {
    getAllData("bonsai-guides", (bonsaiGuidesData) => {
      setBonsaiGuides(bonsaiGuidesData);
      setLoading(false);
    });
    getAllData("species", (speciesData) => {
      setSpecies(speciesData);
    });
  }, []);

  const filteredBonsaiGuides = bonsaiGuides.filter((bonsaiGuide) => {
    if (speciesSearch === "") {
      return true;
    }
    if (bonsaiGuide.commonName === speciesSearch.commonName) {
      return true;
    }
    if (bonsaiGuide.scientificName === speciesSearch.scientificName) {
      return true;
    }
    return false;
  }
  );

  const speciesCanSearchFor = bonsaiGuides.map((bonsaiGuide) => {
    return {
      commonName: bonsaiGuide.commonName,
      scientificName: bonsaiGuide.scientificName,
    };
  });

  // create an array of colours, one for each filteredBonsaiGuides
  if (guideColours.length !== filteredBonsaiGuides.length) {

  let colours = filteredBonsaiGuides.map(() => {
    return "rgb(" + Math.floor(Math.random() * 256) + "," + Math.floor(Math.random() * 256) + "," + Math.floor(Math.random()
    * 256) + ")";
  });
  setGuideColours(colours);
  }

  return (
    <Box>
      <AppBarHome />
      <Box
        sx={{
          padding: "1rem",
          margin: "auto",
          // maxWidth: "1200px",
        
        }}
      >
      <Box
        style={{
          margin: "auto 0",
        }}
      > 
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>

      {/* Title and description */}
        <Typography variant="h4">Bonsai Guides</Typography>
        <Typography gutterBottom
          sx={{
            marginBottom: "1rem",
          }}
        >
          Find bonsai guides where you live. Click on a guide to view more information.
        </Typography>
        <SpeciesSearch
        species={speciesCanSearchFor}
        setSpecies={setSpeciesSearch}
        canAdd={false}
        onSelect={(species, isNew =false) => {
          if (species === null) {
            return;
          }
          setSpeciesSearch({
            commonName: species.commonName,
            scientificName: species.scientificName,
          
          });
        }}
        
        />

      {/* SHows each bonsai guide as a card */}
        <Stack
          direction="row"
          spacing={2}
          style={{
            flexWrap: "wrap",
            overflowY:"auto",
            height:"60vh",
            marginTop: "1rem",
          }}
        >
          

        {loading && (
          <Box
            style={{
              textAlign: "center",
              margin: "2rem 0rem",
            }}
          >
            <CircularProgress />
          </Box>
        )}
        {filteredBonsaiGuides.length === 0 && !loading && (
          <Typography
          variant="body1"
          style={{
            marginTop: "1rem",
          }}
          >
            No bonsai guides for here yet. Try moving the map to a different location or create your own guide!
          </Typography>
        )  
        }
          {filteredBonsaiGuides.map((bonsaiGuide) => {
            return (
              <Box
                key={bonsaiGuide.storageDocumentId}
                style={{
                  padding: "1rem",
                  margin: "1rem",
                  marginLeft:"0rem",
                  width: "100%",
                  border: "2px solid black",
                  boxShadow: "4px 4px 0px 0px rgb(109 112 108)",
                  borderRadius: ".3rem .3rem .3rem .3rem",
                  position: "relative",
                  zIndex: 1,
                  maxHeight:"4.5rem",
                  minHeight:"fit-content",
                  borderRight: "5px solid " + guideColours[filteredBonsaiGuides.indexOf(bonsaiGuide)],
                }}
                onClick={()=> {
                  handleBonsaiGuideClick(bonsaiGuide.storageDocumentId);
                }}
              >
                <Grid container>
                  <Grid item xs={12}
                  >
                    
          <span style={{ fontStyle: "italic", fontWeight:600 }}>  {bonsaiGuide.stage} </span> of the 
          <span style={{ fontStyle: "italic", fontWeight:600 }}> {bonsaiGuide.commonName} ({bonsaiGuide.scientificName})</span> bonsai tree.
                    
                    </Grid>
                  
                  <Grid item xs={6}>
                  <Typography>Created: {(bonsaiGuide.timeDateCreated)? bonsaiGuide.timeDateCreated.toDate().toLocaleDateString(): null}</Typography>
                    
                    </Grid>
                  <Grid item xs={6}>
                    <Typography align="right">Votes: {bonsaiGuide.upVotes? bonsaiGuide.upVotes.length : 0} /{bonsaiGuide.downVotes? bonsaiGuide.downVotes.length : 0}</Typography>
                    </Grid>
                  </Grid>
              </Box>
            );
          })}
          </Stack>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="h4">Map</Typography>
          <Typography>
            Change the map area to find different guides
          </Typography>

      
        <LeafletMap
        onViewChanged={handleMapViewChanged}
        guides={bonsaiGuides}
        colours={guideColours}
        
        />
        </Grid>
        </Grid>

        
      </Box>
      
      </Box>
    </Box>
  );
}

export default ScreenHome;
